import React from 'react';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { SeoMeta } from '@/components/seo/SeoMeta';
import { useCMSContent } from '@/hooks/useCMSContent';
import { renderMarkdown, PageLoading } from './shared';

export const TermsPage = () => {
  const { content, loading } = useCMSContent();

  if (loading) return <PageLoading />;

  const termsContent = content?.footer?.terms_page || 'Innehållet har inte konfigurerats ännu. Gå till Admin > Footer för att redigera.';

  return (
    <div className="bg-[#F8FAFC] min-h-screen" data-testid="terms-page">
      <SeoMeta
        title="Köpvillkor och ångerrätt"
        description="Köpvillkor, ångerrätt och villkor för handel på ByggFynd. Läs innan du beställer byggmaterial och verktyg."
        canonicalPath="/kopvillkor"
      />
      <div className="container-main py-8">
        <Breadcrumbs items={[{ label: 'Köpvillkor & Ångerrätt' }]} />
        
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-black text-[#0F172A] mb-8">Köpvillkor & Ångerrätt</h1>
          
          <div className="bg-white rounded-md shadow-sm p-8">
            <div className="prose max-w-none">
              {renderMarkdown(termsContent)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
